import artifact from '$houdini/artifacts/UpdateDashboardChartOptions'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateDashboardChartOptionsStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
